import { ActivatedRoute } from '@angular/router';
import { Investor } from './../../shared/models/investor';
import { AssetService } from './../../../services/asset.service';
import { Component, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { InvestorDataService } from '../../../core/investor-data.service';
import { Options } from 'ng5-slider';
import { SuggestionDataService } from '../../../services/suggestion-data.service';
import { Suggestion } from '../../shared/models/suggestion';
import {
  trigger,
  transition,
  animate,
  style,
  state,
  group
} from '@angular/animations';
import {
  mf_filters,
  bonds_filters,
  fd_filters,
  pms_filters,
  cash_filters,
  re_filters,
  iequity_filters,
  de_filters
} from './filters';

import {
  MutualFundsFields,
  BondsFields,
  FDFields,
  PMSFields,
  CashFields,
  RealEstateFields,
  InternationalEquityFields,
  PreciousMetalsFields,
  DirectEquityFields,
  Filter,
  FilterType,
  AssetPage,
  ToggleSettingsString
} from './types';

// declare var $: any;
@Component({
  selector: 'app-asset-catalog',
  templateUrl: './asset-catalog.component.html',
  styleUrls: ['./asset-catalog.component.css'],
  animations: [
    trigger('slideInOut', [
      state(
        'in',
        style({
          'max-height': '500px',
          opacity: '1',
          visibility: 'visible'
        })
      ),
      state(
        'out',
        style({
          'max-height': '0px',
          opacity: '0',
          visibility: 'hidden'
        })
      ),
      transition('in => out', [
        group([
          animate(
            '400ms ease-in-out',
            style({
              opacity: '0'
            })
          ),
          animate(
            '600ms ease-in-out',
            style({
              'max-height': '0px'
            })
          ),
          animate(
            '700ms ease-in-out',
            style({
              visibility: 'hidden'
            })
          )
        ])
      ]),
      transition('out => in', [
        group([
          animate(
            '1ms ease-in-out',
            style({
              visibility: 'visible'
            })
          ),
          animate(
            '600ms ease-in-out',
            style({
              'max-height': '500px'
            })
          ),
          animate(
            '800ms ease-in-out',
            style({
              opacity: '1'
            })
          )
        ])
      ])
    ])
  ]
})
export class AssetCatalogComponent implements OnInit {
  investor: Investor;
  currentPage: AssetPage;

  public pages = AssetPage;

  editableBalance;

  public CashFields = CashFields;
  public BondsFields = BondsFields;
  public FDFields = FDFields;
  public MutualFundsFields = MutualFundsFields;
  public DirectEquityFields = DirectEquityFields;
  public PMSFields = PMSFields;
  public InternationalEquityFields = InternationalEquityFields;
  public RealEstateFields = RealEstateFields;
  public PreciousMetalsFields = PreciousMetalsFields;

  manualRefresh: EventEmitter<void> = new EventEmitter<void>();

  currentSuggestion: Suggestion;
  items: Object = {};
  myTotalAssets = 0;

  DefaultOptions: Options = {
    step: 1
  };
  showSettings = [];

  count: { [k in ToggleSettingsString]?: { [s: string]: number } } = {};

  adjustmentAmount = 0;
  mf_settings = {
    // min: 0,
    // max: 0,
    age_min: 1,
    age_max: 100,
    age_options: {
      ...this.DefaultOptions,
      floor: 1,
      ceil: 100,
      translate: (value: number): string => {
        return value + ' Years';
      }
    },
    fund_size_min: 1,
    fund_size_max: 40000,
    fund_options: {
      ...this.DefaultOptions,
      floor: 1,
      ceil: 40000,
      translate: (value: number): string => {
        return '₹' + value + ' Crore';
      }
    },
    asset_class_items: [],
    scheme_category_items: [],
    amc_items: [],
    suggested_opt_items: [],
    strategy_items: [],
    benchmark_items: [],
    risk_items: [],
    timeframe_items: [],
    tax_items: [],
    selected_asset_class_items: {},
    selected_scheme_category_items: {},
    selected_amc_items: {},
    selected_suggested_opt_items: {},
    selected_strategy_items: [],
    selected_benchmark_items: [],
    selected_risk_items: [],
    selected_timeframe_items: [],
    selected_tax_items: []
  };

  mf_filters: Filter[] = mf_filters;

  bonds_settings = {
    types_items: [],
    registrar_items: [],
    selected_types_items: {},
    selected_registrar_items: {},

    maturity_min: 1,
    maturity_max: 100,
    maturity_options: {
      ...this.DefaultOptions,
      floor: 1,
      ceil: 100,
      translate: (value: number): string => {
        return value + ' Years';
      }
    },
    price_min: 1,
    price_max: 100,
    price_options: {
      ...this.DefaultOptions,
      floor: 1,
      ceil: 100,
      translate: (value: number): string => {
        return '₹' + value;
      }
    },
    roi_min: 5,
    roi_max: 12,
    roi_options: {
      ...this.DefaultOptions,
      floor: 5,
      ceil: 12,
      step: 0.01,
      translate: (value: number): string => {
        return value + ' %';
      }
    }
  };

  bonds_filters: Filter[] = bonds_filters;

  fd_settings = {
    category_items: [],
    tax_items: [],
    bank_items: [],
    nbfc_items: [],
    selected_category_items: {},
    selected_tax_items: {},
    selected_bank_items: {},
    selected_nbfc_items: {},
    roi_min: 4,
    roi_max: 10,
    roi_options: {
      ...this.DefaultOptions,
      floor: 4,
      ceil: 10,
      step: 0.05,
      translate: (value: number): string => {
        return value + ' %';
      }
    },
    price_min: 1,
    price_max: 100,
    price_options: {
      ...this.DefaultOptions,
      floor: 1,
      ceil: 100,
      translate: (value: number): string => {
        return '₹' + value;
      }
    }
  };

  fd_filters: Filter[] = fd_filters;

  pms_settings = {
    company_item: [],
    selected_company_items: {}
  };

  pms_filters: Filter[] = pms_filters;

  cash_settings = {
    account_type: [],
    selected_account_type: {}
  };

  cash_filters: Filter[] = cash_filters;

  re_settings = {
    type: [],
    selected_types: {}
  };

  re_filters: Filter[] = re_filters;

  iequity_settings = {
    type: [],
    selected_types: {}
  };

  iequity_filters: Filter[] = iequity_filters;

  pm_settings = {
    type: [],
    selected_types: {}
  };

  pm_filters: Filter[] = pms_filters;

  de_settings = {
    type: [],
    selected_types: {}
  };

  de_filters: Filter[] = de_filters;

  fd_totals = 0;
  bonds_totals = 0;
  debt_totals = 0;
  mf_totals = 0;
  de_totals = 0;
  pms_totals = 0;
  equity_totals = 0;
  cash_totals = 0;
  iequity_totals = 0;
  pm_totals = 0;
  re_totals = 0;

  sip_fd_totals = 0;
  sip_bonds_totals = 0;
  sip_debt_totals = 0;
  sip_mf_totals = 0;
  sip_de_totals = 0;
  sip_pms_totals = 0;
  sip_equity_totals = 0;
  sip_cash_totals = 0;
  sip_iequity_totals = 0;
  sip_pm_totals = 0;
  sip_re_totals = 0;

  assetCatalogData = {
    [this.pages.fd]: {},
    [this.pages.bonds]: {},
    [this.pages.mf]: {},
    [this.pages.cash]: {},
    [this.pages.de]: {},
    [this.pages.pm]: {},
    [this.pages.pms]: {},
    [this.pages.iequity]: {},
    [this.pages.re]: {}
  };

  assetCatalogSIPData = {
    [this.pages.fd]: {},
    [this.pages.bonds]: {},
    [this.pages.mf]: {},
    [this.pages.cash]: {},
    [this.pages.de]: {},
    [this.pages.pm]: {},
    [this.pages.pms]: {},
    [this.pages.iequity]: {},
    [this.pages.re]: {}
  };

  constructor(
    private __assetService: AssetService,
    private ids: InvestorDataService,
    private _ActivatedRoute: ActivatedRoute,
    private __suggestionDataService: SuggestionDataService
  ) { }

  onAdjustmentChange(e){
    // console.log(e);
    this.myTotalAssets = this.investor.total_opening_balance + this.adjustmentAmount;
  }
  onChange($ev) {
    console.log("vc", $ev);
  }

  toggleSettings(item) {
    this.showSettings[item] = !(this.showSettings[item] || false);
    this.manualRefresh.emit();
  }

  ngOnInit() {
    const iid = this._ActivatedRoute.snapshot.params['uid'];
    this.ids
      .getInvestorByKey(iid)
      .get()
      .then(value => {
        this.investor = new Investor(value.data());
        this.myTotalAssets = this.investor.total_opening_balance;
        this.__suggestionDataService
          .getAssetSuggestions(this.investor.iid)
          .subscribe(suggestionData => {
            this.assetCatalogData = {
              ...this.assetCatalogData,
              ...JSON.parse(suggestionData['data'])
            };
            this.adjustmentAmount = suggestionData['adjustmentAmount']
            this.myTotalAssets = this.investor.total_opening_balance + this.adjustmentAmount;
            this.assetCatalogSIPData = {
              ...this.assetCatalogSIPData,
              ...JSON.parse(suggestionData['sipData'])
            };

            Object.keys(this.assetCatalogData).forEach(page => {
              this.updateCalculations(page);
              this.cleanData(page);
            });

            Object.keys(this.assetCatalogSIPData).forEach(page => {
              this.updateSIPCalculations(page);
              this.cleanSIPData(page);
            });
          });

        this.__suggestionDataService
          .getLatestSuggestionData(this.investor.iid)
          .valueChanges()
          .subscribe(suggestion => {
            this.currentSuggestion = suggestion[0];
            console.log(this.currentSuggestion);
          });
      });
    this.changePage(this.pages.mf);
    this.loadPageData(this.pages.mf);
    this.loadPageData(this.pages.fd);
    this.loadPageData(this.pages.bonds);
    this.loadPageData(this.pages.cash);
    this.loadPageData(this.pages.re);
    this.loadPageData(this.pages.pms);
    this.loadPageData(this.pages.pm);
    this.loadPageData(this.pages.de);
    this.loadPageData(this.pages.iequity);

    // $(document).ready(function () {
    //   $('.page-btn').click(function () {
    //     if ($('.page-btn').hasClass('active')) {
    //       $('.page-btn').removeClass('active');
    //       $(this).addClass('active');
    //     } else {
    //       $(this).addClass('active');
    //     }
    //   });

    //   $('.sub-page-btn').click(function () {
    //     if ($('.sub-page-btn').hasClass('active-sub')) {
    //       $('.sub-page-btn').removeClass('active-sub');
    //       $(this).addClass('active-sub');
    //     } else {
    //       $(this).addClass('active-sub');
    //     }
    //   });
    // });
    // todo. fix page highlight logic
  }

  getTotalSourceAmount() {
    return (this.investor.total_investing_SIP_amount || 0 + this.investor.total_liquid_financial_assets_value || 0 + this.investor.total_other_assets_value || 0);
  }

  getMonthlySurplusAmount() {
    return Math.round(this.investor.total_investing_SIP_amount / 12) || '';
  }
  
  cleanData(page) {
    // console.log(this.items, this.assetCatalogData);
    if (this.items && this.assetCatalogData) {
      const pageData = this.items[page];

      if (pageData) {
        const hashmap = pageData.map(item => item.hash);
        const thisPageData = {};
        Object.keys(this.assetCatalogData[page]).forEach(hash => {
          if (hashmap.indexOf(hash) > -1) {
            thisPageData[hash] = this.assetCatalogData[page][hash];
          }
        });

        this.assetCatalogData = {
          ...this.assetCatalogData,
          [page]: thisPageData
        };
      }
      this.updateCalculations(page);
    }
  }

  cleanSIPData(page) {
    // console.log(this.items, this.assetCatalogData);
    if (this.items && this.assetCatalogSIPData) {
      const pageData = this.items[page];

      if (pageData) {
        const hashmap = pageData.map(item => item.hash);
        const thisPageData = {};
        Object.keys(this.assetCatalogSIPData[page]).forEach(hash => {
          if (hashmap.indexOf(hash) > -1) {
            thisPageData[hash] = this.assetCatalogSIPData[page][hash];
          }
        });

        this.assetCatalogSIPData = {
          ...this.assetCatalogSIPData,
          [page]: thisPageData
        };
      }
      this.updateSIPCalculations(page);
    }
  }

  changePage(pageName: AssetPage) {
    console.log(pageName);
    this.currentPage = pageName;
    if (typeof this.items[pageName] == 'undefined') {
      this.loadPageData(pageName);
    }
  }

  loadPageData(pageName: AssetPage) {
    this.__assetService
      .getAsset(pageName)
      .get()
      .then(value => {
        console.log(JSON.parse(value.data().data));
        this.items[pageName] = JSON.parse(value.data().data);
        this.extractFilterData(pageName);
        this.cleanData(pageName);
        this.cleanSIPData(pageName);
      })
      .catch(console.error);
  }

  extractFilterData(pageName: AssetPage) {
    console.log(pageName);
    switch (pageName) {
      case this.pages.cash:
        this.cash_settings.account_type = this.extractUnique(
          this.items[pageName],
          CashFields.type
        );
        this.calculateFilterCounts('cash');
        break;
      case this.pages.re:
        this.re_settings.type = this.extractUnique(
          this.items[pageName],
          RealEstateFields.type
        );
        this.calculateFilterCounts('re');
        break;
      case this.pages.iequity:
        this.iequity_settings.type = this.extractUnique(
          this.items[pageName],
          InternationalEquityFields.type
        );
        this.calculateFilterCounts('iequity');
        break;
      case this.pages.pm:
        this.pm_settings.type = this.extractUnique(
          this.items[pageName],
          PreciousMetalsFields.type
        );
        this.calculateFilterCounts('pm');
        break;
      case this.pages.fd:
        this.fd_settings.tax_items = this.extractUnique(
          this.items[pageName],
          FDFields.tax
        );
        this.fd_settings.category_items = this.extractUnique(
          this.items[pageName],
          FDFields.category
        );
        this.fd_settings.bank_items = this.extractUnique(
          this.items[pageName],
          FDFields.bank
        );
        this.fd_settings.nbfc_items = this.extractUnique(
          this.items[pageName],
          FDFields.nbfc
        );
        this.calculateFilterCounts('fd');
        break;
      case this.pages.bonds:
        this.bonds_settings.types_items = this.extractUnique(
          this.items[pageName],
          BondsFields.type
        );
        this.bonds_settings.registrar_items = this.extractUnique(
          this.items[pageName],
          BondsFields.registrar
        );
        this.calculateFilterCounts('bonds');
        break;
      case this.pages.mf:
        // calculate minimum amount for age. Also using that for initializing the current min of the filter.
        this.mf_settings.age_options.floor = this.mf_settings.age_min = this.extractMin(
          this.items[pageName],
          MutualFundsFields.age
        );

        // calculate max amount for age. Also using that for initializing the current max of the filter.
        this.mf_settings.age_options.ceil = this.mf_settings.age_max = this.extractMax(
          this.items[pageName],
          MutualFundsFields.age
        );
        // Refreshing age's Slider
        this.mf_settings.age_options = Object.assign(
          {},
          this.mf_settings.age_options
        );

        this.mf_settings.fund_options.floor = this.mf_settings.fund_size_min = this.extractMin(
          this.items[pageName],
          MutualFundsFields.size
        );
        this.mf_settings.fund_options.ceil = this.mf_settings.fund_size_max = this.extractMax(
          this.items[pageName],
          MutualFundsFields.size
        );
        // refreshing fund size slider
        this.mf_settings.fund_options = Object.assign(
          {},
          this.mf_settings.fund_options
        );

        this.mf_settings.asset_class_items = this.extractUnique(
          this.items[pageName],
          MutualFundsFields.class
        );
        this.mf_settings.scheme_category_items = this.extractUnique(
          this.items[pageName],
          MutualFundsFields.scheme
        );
        this.mf_settings.amc_items = this.extractUnique(
          this.items[pageName],
          MutualFundsFields.amc
        );
        this.mf_settings.suggested_opt_items = this.extractUnique(
          this.items[pageName],
          MutualFundsFields.options
        );
        this.mf_settings.strategy_items = this.extractUnique(
          this.items[pageName],
          MutualFundsFields.strategy
        );
        this.mf_settings.benchmark_items = this.extractUnique(
          this.items[pageName],
          MutualFundsFields.benchmark
        );
        this.mf_settings.risk_items = this.extractUnique(
          this.items[pageName],
          MutualFundsFields.risk
        );
        this.mf_settings.timeframe_items = this.extractUnique(
          this.items[pageName],
          MutualFundsFields.timeframe
        );
        this.mf_settings.tax_items = this.extractUnique(
          this.items[pageName],
          MutualFundsFields.tax
        );
        this.mf_settings = Object.assign({}, this.mf_settings);
        this.calculateFilterCounts('mf');
        break;
      case this.pages.pms:
        this.pms_settings.company_item = this.extractUnique(
          this.items[pageName],
          PMSFields.name
        );
        this.calculateFilterCounts('pms');
        break;
      case this.pages.de:
        this.de_settings.type = this.extractUnique(
          this.items[pageName],
          DirectEquityFields.type
        );
        this.calculateFilterCounts('de');
        break;
      default:
        break;
    }
  }

  extractMin(data, field): number {
    return data.reduce((accumulator, item, index) => {
      if (index == 0) {
        return item[field];
      }
      if (item[field] < accumulator) {
        return item[field];
      }
      return accumulator;
    }, 0);
  }

  extractMax(data, field): number {
    return data.reduce((accumulator, item, index) => {
      if (index == 0) {
        return item[field];
      }
      if (item[field] > accumulator) {
        return item[field];
      }
      return accumulator;
    }, 0);
  }

  extractUnique(data, field): string[] {
    return Object.keys(
      data.reduce((accumulator, item) => {
        return {
          ...accumulator,
          [item[field]]: 1
        };
      }, {})
    );
  }

  updateCalculations(page) {
    switch (page) {
      case this.pages.fd:
        this.fd_totals = this._calculateTotals(page);
        this.debt_totals = this.fd_totals + this.bonds_totals;
        break;
      case this.pages.bonds:
        this.bonds_totals = this._calculateTotals(page);
        this.debt_totals = this.fd_totals + this.bonds_totals;
        break;
      case this.pages.mf:
        this.mf_totals = this._calculateTotals(page);
        this.equity_totals = this.mf_totals + this.de_totals + this.pms_totals;
        break;
      case this.pages.de:
        this.de_totals = this._calculateTotals(page);
        this.equity_totals = this.mf_totals + this.de_totals + this.pms_totals;
        break;
      case this.pages.pms:
        this.pms_totals = this._calculateTotals(page);
        this.equity_totals = this.mf_totals + this.de_totals + this.pms_totals;
        break;
      case this.pages.cash:
        this.cash_totals = this._calculateTotals(page);
        break;
      case this.pages.pm:
        this.pm_totals = this._calculateTotals(page);
        break;
      case this.pages.iequity:
        this.iequity_totals = this._calculateTotals(page);
        break;
      case this.pages.re:
        this.re_totals = this._calculateTotals(page);
        break;
    }
  }

  updateSIPCalculations(page) {
    console.log(page, this.assetCatalogSIPData);

    switch (page) {
      case this.pages.fd:
        this.sip_fd_totals = this._calculateTotals(page, true);
        this.sip_debt_totals = this.sip_fd_totals + this.sip_bonds_totals;
        break;
      case this.pages.bonds:
        this.sip_bonds_totals = this._calculateTotals(page, true);
        this.sip_debt_totals = this.fd_totals + this.sip_bonds_totals;
        break;
      case this.pages.mf:
        this.sip_mf_totals = this._calculateTotals(page, true);
        this.sip_equity_totals =
          this.sip_mf_totals + this.sip_de_totals + this.sip_pms_totals;
        break;
      case this.pages.de:
        this.sip_de_totals = this._calculateTotals(page, true);
        this.sip_equity_totals =
          this.sip_mf_totals + this.sip_de_totals + this.sip_pms_totals;
        break;
      case this.pages.pms:
        this.sip_pms_totals = this._calculateTotals(page, true);
        this.sip_equity_totals =
          this.sip_mf_totals + this.sip_de_totals + this.sip_pms_totals;
        break;
      case this.pages.cash:
        this.sip_cash_totals = this._calculateTotals(page, true);
        break;
      case this.pages.pm:
        this.sip_pm_totals = this._calculateTotals(page, true);
        break;
      case this.pages.iequity:
        this.sip_iequity_totals = this._calculateTotals(page, true);
        break;
      case this.pages.re:
        this.sip_re_totals = this._calculateTotals(page, true);
        break;
    }
  }

  _calculateTotals(page, isSip = false) {
    const key = isSip ? 'assetCatalogSIPData' : 'assetCatalogData';
    return Object.keys(this[key][page]).reduce((accumulator, item) => {
      if (this[key][page][item]) {
        return accumulator + this[key][page][item];
      }
      return accumulator;
    }, 0);
  }

  getPageFromMode(mode) {
    switch (mode) {
      case 'mf':
        return this.pages.mf;
      case 'bonds':
        return this.pages.bonds;
      case 'fd':
        return this.pages.fd;
      case 'pms':
        return this.pages.pms;
      case 'cash':
        return this.pages.cash;
      case 'pm':
        return this.pages.pm;
      case 'iequity':
        return this.pages.iequity;
      case 're':
        return this.pages.re;
      case 'de':
        return this.pages.de;
    }
  }
  calculateFilterCounts(
    mode:
      | 'mf'
      | 'bonds'
      | 'fd'
      | 'pms'
      | 'de'
      | 'cash'
      | 'iequity'
      | 'pm'
      | 're'
  ) {
    const filters = mode + '_filters';
    const settings = mode + '_settings';
    this[filters].forEach(currentFilter => {
      if (!this.count[currentFilter.toggleSettingsString]) {
        this.count[currentFilter.toggleSettingsString] = {};
      }
      if (currentFilter.type == FilterType.Options) {
        let items = Object.assign([], this.items[this.getPageFromMode(mode)]);
        this[filters].forEach(filter => {
          if (currentFilter.field != filter.field) {
            if (filter.type == FilterType.Slider) {
              // console.log(filter, "Slider");
              const min = this[settings][filter.min_key];
              const max = this[settings][filter.max_key];
              items = items.filter(it => {
                return it[filter.field] >= min && it[filter.field] <= max;
              });
              // console.log(JSON.parse(JSON.stringify(items)), min, max);
            } else if (filter.type == FilterType.Options) {
              // console.log(filter.field, "Options");
              const elements = this[settings][filter.selected_items_key];
              const reducedElements = Object.keys(elements).reduce(
                (accumulator, item) => {
                  if (elements[item] == true) {
                    return [...accumulator, item];
                  }
                  return accumulator;
                },
                []
              );
              if (reducedElements.length == 0) {
                return items;
              }
              items = items.filter(it => {
                return reducedElements.indexOf(it[filter.field]) > -1;
              });
              // console.log(JSON.parse(JSON.stringify(items)));
            }
          }
        });

        console.log(
          currentFilter.toggleSettingsString,
          JSON.parse(JSON.stringify(items))
        );

        this[settings][currentFilter.items_key].forEach(selectedItem => {
          this.count[currentFilter.toggleSettingsString][
            selectedItem
          ] = items.filter(it => {
            return [selectedItem].indexOf(it[currentFilter.field]) > -1;
          }).length;
        });
      }
    });
  }

  flipValues(head) {
    this.mf_settings[head] = {
      ...this.mf_settings[head]
    };
    this.calculateFilterCounts('mf');
  }

  flipValuesPMS(head) {
    this.pms_settings[head] = {
      ...this.pms_settings[head]
    };
    this.calculateFilterCounts('bonds');
  }

  flipValuesBonds(head) {
    this.bonds_settings[head] = {
      ...this.bonds_settings[head]
    };
    this.calculateFilterCounts('bonds');
  }

  flipValuesFD(head) {
    this.fd_settings[head] = {
      ...this.fd_settings[head]
    };
    this.calculateFilterCounts('fd');
  }

  flipValuesCash(head) {
    this.cash_settings[head] = {
      ...this.cash_settings[head]
    };
    this.calculateFilterCounts('cash');
  }

  flipValuesPM(head) {
    this.pm_settings[head] = {
      ...this.pm_settings[head]
    };
    this.calculateFilterCounts('pm');
  }

  flipValuesRE(head) {
    this.re_settings[head] = {
      ...this.re_settings[head]
    };
    this.calculateFilterCounts('re');
  }

  flipValuesIEquity(head) {
    this.iequity_settings[head] = {
      ...this.iequity_settings[head]
    };
    this.calculateFilterCounts('iequity');
  }

  flipValuesDE(head) {
    this.de_settings[head] = {
      ...this.de_settings[head]
    };
    this.calculateFilterCounts('de');
  }

  saveAssetData() {
    this.__suggestionDataService.saveAssetSuggestions(
      this.assetCatalogData,
      this.assetCatalogSIPData,
      this.investor.iid,
      this.adjustmentAmount,
      () => {
        console.log('save successfully');
      },
      error => {
        console.log(error);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/asset-selection/asset-catalog/asset-catalog.component.ts